import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  hero: {
    objectFit: "cover",
    width: "100%",
    height: 230,
  },
  wrapHeader: {
    textAlign: "center",
    paddingTop: "70px",
  },
  wrapCard: {
    padding: 20,
  },
  wrapGrid: {
    textAlign: "center",
  },
  wrapList: {
    marginTop: "100px",
  },
  wrapKredit: {
    paddingBottom: "100px",
  },
  liquidTitle: {
    fontWeight: "bold",
    color: theme.palette.textColor.primeTextColor,
  },
  liquidPrimary: {
    fontSize: 14,
  },
  liquidSecond: {
    fontSize: 14,
    color: theme.palette.textColor.gray,
  },
  liquidErr: {
    fontSize: 14,
    color: "#FF4129",
  },
  liquidThird: {
    fontSize: 12,
    color: theme.palette.primary.main,
  },
  secondItem: {
    marginTop: "20px",
  },
  wrapBtnList: {
    display: "flex",
    justifyContent: "center",
  },
  wrapList:{
    marginTop:"70px"
  },
  fullWidth: {
    width: "100%",
  },
  paper: {
    maxHeight: "100vh",
    height: "100vh",
  },
  root: {
    margin: 0,
    // marginLeft: -8,
    borderRadius: 0,
  },
  btn: {
    textTransform: "capitalize",
  },
  list: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: 16,
  },
  listDialogKomfirm: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 0px",
  },
  listTitle: {
    color: "black",
    fontSize: 14,
  },
  listSubTitle: {
    color: "#111014",
    textTransform: "capitalize",
  },
  borderTop: {
    borderTop: "1px solid #f3f3f3",
  },
  
}));

export default useStyles;
